export default __webpack_public_path__ + "static/header-marketing-1ec69610d7c79b4355d188a7c986d091.png";